import { Text, View } from "react-native";
import { useResidentContext } from "../../provider/ResidentProvider";
import { useMemo, useRef } from "react";
import KeyValueList from "ui/organisms/KeyValueList";
import { EditResidentAssessmentModal } from "../modals/EditResidentAssessmentModal";
import { EditButton } from "../../molecules/EditButton";
import ViewDocuments from "app/components/molecules/ViewDocuments";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";
import { Icon, InfoIcon } from "ui/gluestack/icon";
import { Link } from "ui/gluestack/link";

export default function ResidentAssessmentTemplate() {
  const { resident } = useResidentContext();
  const ref =
    useRef<React.ComponentRef<typeof EditResidentAssessmentModal>>(null);
  const startEdit = () => {
    ref.current?.show(resident);
  };

  const assessments = useMemo(
    () => [
      {
        label: "Barthel Score",
        value: (
          <View className="mt-8 mb-12">
            <ViewDocuments
              documents={resident?.barthel_score_medias ?? []}
              className="mb-4"
            />
            <View className="flex-row gap-1">
              <Icon as={InfoIcon} color="#475467" />
              <Text className="text-typography-600 normal-case">
                To modify the Barthel Score, please navigate to the{" "}
                <Link href={`/residents/${resident!.id}/barthel-score`}>
                  Barthel Score page.
                </Link>
              </Text>
            </View>
          </View>
        ),
      },
      {
        label: "Other Assements",
        value: (
          <ViewDocuments
            documents={resident?.other_assessments_medias ?? []}
            className="mt-8 mb-12"
          />
        ),
      },
    ],
    [resident],
  );

  return (
    <View className="resident-container">
      <EditButton
        startEdit={startEdit}
        permission={PermissionsEnums.UPDATE_RESIDENT}
      />

      {resident?.barthel_score_medias?.length ||
      resident?.other_assessments_medias?.length ? (
        <KeyValueList items={assessments} />
      ) : (
        <Text className="text-typography-600">
          No assessment details listed.
        </Text>
      )}

      <EditResidentAssessmentModal ref={ref} />
    </View>
  );
}
